import { render, staticRenderFns } from "./AccountsEdit.vue?vue&type=template&id=1146a76c&scoped=true"
import script from "./AccountsEdit.vue?vue&type=script&lang=js"
export * from "./AccountsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146a76c",
  null
  
)

export default component.exports